import atmoClient from "@/setup/clients/atmoClient";
import RestClient from "@/api/utils/baseRestClient";
import _ from "lodash";

class SampleFlaskPrepRestClient extends RestClient {
  handleSpecialSnakeCase(data) {
    const mapping = {
      autre_support: "AUTRE_SUPPORT",
      barbotage: "BARBOTAGE",
      blanc_barbotage: "BLANC_BARBOTAGE",
      blanc_filtrage: "BLANC_FILTRAGE",
      blanc_rincage: "BLANC_RINCAGE",
      filtre: "FILTRE",
      rendement: "RENDEMENT",
      rincage: "RINCAGE",
    };
    return _.mapKeys(data, (value, key) => _.get(mapping, key, key));
  }
  handleSpecialCamelCase(data) {
    const mapping = {
      autreSupport: "AUTRE_SUPPORT",
      barbotage: "BARBOTAGE",
      blancBarbotage: "BLANC_BARBOTAGE",
      blancFiltrage: "BLANC_FILTRAGE",
      blancRincage: "BLANC_RINCAGE",
      filtre: "FILTRE",
      rendement: "RENDEMENT",
      rincage: "RINCAGE",
    };
    return _.mapKeys(data, (value, key) => _.get(mapping, key, key));
  }
  async bulkCreate(form, config) {
    form = this.toSnake([...form]);
    const url = `${this.path}/bulk_create/`;
    const response = await this.client.post(url, form, config);
    return response.data.map((item) => this.toCamel(item));
  }
}

export const sampleFlaskPropRestClient = new SampleFlaskPrepRestClient(
  atmoClient,
  "sampleflaskpreps"
);
